<div class="modal-header  d-flex flex-column p-3 " style="background: #007aff;">
  <div style="background:#87b0d9 ; width:100% " class="w-100" >
    <div class=" text-center my-2">
      <b>{{title}}</b>
    </div>
    <div class="modal-footer flex-row justify-content-center" *ngIf="title != 'Session Expired'">
      <button type="button" class="btn btn-success" (click)="accept()">Confirm</button>
      <button type="button" class="btn btn-danger" (click)="decline()">Cancel</button>
    </div>
    <div class="modal-footer" *ngIf="title == 'Session Expired'">
      <button type="button" class="btn btn-success" (click)="logout()">Logout</button>
    </div>
  </div>
</div>